import { AfterViewInit, Component, OnInit, ViewChild,
  ViewContainerRef,
  ComponentFactoryResolver,
  ComponentRef,
  ComponentFactory } from '@angular/core';
import { Router } from '@angular/router';
import { CountryModel } from 'src/app/masters/country/country.model';
import { MasterService } from 'src/app/masters/master.service';
import { OrganismModel } from '../organisms/organism.model';
import { AddHospitalComponent } from './add-hospital/add-hospital.component';
import { HospitalModel } from './hospital.model';
import { HospitalService } from './hospitals.service';
import * as CommonConstants from '../../utils/common.constants';
import { ToastrService } from 'ngx-toastr';
import { PartnerSearchComponent } from '../partner-search/partner-search.component';
import { LoaderService } from 'src/app/common/loader.service';
import { SharedService } from 'src/app/utils/shared.service';


@Component({
  selector: 'app-hospitals',
  templateUrl: './hospitals.component.html',
  styleUrls: ['./hospitals.component.scss']
})
export class HospitalsComponent implements OnInit {


  organisms: OrganismModel[];
  countries: CountryModel[];
  towns: any[];
  columnDefs: any[];
  departments: any[];
  specialities: any[];
  subSpecialities: any[];
  hyperSpecialities: any[];
  
  rowData: HospitalModel[];
  private defaultColDef;
  addHospital;
  hospitalSearch: HospitalModel = new HospitalModel();
  startIndex;
  rowsPerPage;
  totalRecords;
  paginationSize = CommonConstants.PAGINATION_SIZE;
  toggleColumn:boolean = true;

  @ViewChild(PartnerSearchComponent,{static:true})   pSearch : PartnerSearchComponent;
  addressTypeList : any[];

  @ViewChild(AddHospitalComponent, { static: true }) newHospital: AddHospitalComponent;
  priv_addHosp: any;
  @ViewChild(AddHospitalComponent, { static: true }) set Content(newHospitalRef) {
    this.newHospital = newHospitalRef;
  }
 
  constructor(public router: Router, private masterService: MasterService, private hospitalService: HospitalService
    , private toasterService: ToastrService, private CFR: ComponentFactoryResolver, private loaderService: LoaderService,private sharedService:SharedService) {
    this.hospitalSearch.orgsmId = this.hospitalSearch.cotryId = this.hospitalSearch.townId = null;
    this.loadMasterData();
    this.columnDefs = [
      // { headerName: 'Id', field: 'hospiId' },
      { headerName: 'Name', field: 'compaVaNameEn'},
      { headerName: 'Organisms', field: 'orgName', width: 250},
      { headerName: 'Email', field: 'compaVaEmail' },
      { headerName: 'Phone', field: 'compaVaWorkPhone'},
      { headerName: 'Fax', field: 'compaVaWorkFax'},
      { headerName: 'Employees', field: 'compaNuNumberEmployees' }
      /* {headerName: 'Id', field: 'orgsmId', width: 50},
      {headerName: 'Code', field: 'orgsmCode', width: 60},
      {headerName: 'Name', field: 'compaVaNameEn',width: 150}, */
    ];
    this.defaultColDef = { resizable: true };
    
    /* this.hospitalService.getHospitals(0).subscribe(response => {
      this.rowData = response['result'];
    }) */

  }

  ngOnInit() {
    this.priv_addHosp=this.sharedService.hasPrivilege(CommonConstants.PRIV_ADD_HOSPITAL);
    this.pSearch.partnerType=CommonConstants.PARTNER_HOSPITAL_TYPE;
    this.pSearch.pSearch["active"]=true;
    this.searchHospitals();
  }

  loadMasterData() {
    this.masterService.getOrganisms().subscribe(response => {
      if (response && response['result']) {
        this.organisms = response['result'];
      }
    })

    this.masterService.getCountry().subscribe(response => {
      if (response && response['result']) {
        this.countries = response['result'];

      }
    })

    this.masterService.getTown().subscribe(response => {
      if (response && response['result']) {
        this.towns = response['result'];
      }
    })
    this.masterService.getDepartments().subscribe(response => {
      if (response && response['result']) {
        this.departments = response['result'];
      }
    })
    this.masterService.getSpecialities().subscribe(response => {
      if (response && response['result']) {
        this.specialities = response['result'];
      }
    })

    this.masterService.getSubSpecialities().subscribe(response => {
      if (response && response['result']) {
        this.subSpecialities = response['result'];
      }
      })
      
      this.masterService.getHyperSpecialities().subscribe(response => {
        if (response && response['result']) {
          this.hyperSpecialities = response['result'];
        }
      })
      this.masterService.getAddressTypes().subscribe(response => {
        if (response['code'] == 'S0000') {
          this.addressTypeList = response['result'];
        }
      });

  }
  addNewHospital() {
    this.router.navigate(['addHospital']);
    this.newHospital.addHospitalTitle = true;
    this.newHospital.editHospitalTitle = false;
  }

  loadHospitalById(event: any) {
    this.loaderService.display(true);
    this.hospitalService.getHospitalsById(event.data.hospiId).subscribe(res => {
      if (res['code'] == 'S0000') {
        let response = res['result'];
        this.newHospital.hospitalForm.patchValue({
          hospiId: response["hospiId"],
          orgsmId: response["orgsmId"],
          compaVaEmail: response["compaVaEmail"],
          compVaHomepage: response["compVaHomepage"],
         // compaVaMobilePhone1: response["compaVaMobilePhone1"],
         // compaVaMobilePhone2: response["compaVaMobilePhone2"],
          compaVaName: response["compaVaName"],
          compaVaNameEn: response["compaVaNameEn"],
          compaNuNumberEmployees: response["compaNuNumberEmployees"],
          compaVaVatRegistrationNo: response["compaVaVatRegistrationNo"],
         // compaVaWorkFax: response["compaVaWorkFax"],
         // compaVaWorkPhone: response["compaVaWorkPhone"],
          leforId: response["leforId"],
          admntId: response["admntId"],
          certiId: response["certiId"],
          paCatId: response["paCatId"],
          pcTypId: response["pcTypId"],
          paGrpId: response["paGrpId"],
          hospiBlProposeFormation: response["hospiBlProposeFormation"],
          hospiBlProposeInternship: response["hospiBlProposeInternship"],
          nationalId: response["nationalId"],
          code: response["code"],
          upload: response["upload"],
          staRecCode: response["staRecCode"] === 'A' ? true : false
        });

        response.hospAddressList = response.hospAddressList.map(item => ({
          ...item,
          addressType: item.typeId ? this.addressTypeList.find(obj => +obj.typeId === +item.typeId).description: null,
          townName: item.townId ? this.towns.find(town => town.townId === item.townId).townDescEn : null,
          countryName: item.cotryId ? this.countries.find(country => country.cotryId === item.cotryId).cotryDescEn : null
        }));
        response.hospSpecialityList = response.hospSpecialityList.map(item => ({
          ...item,
          deptName: item.deptmId ? this.departments.find(obj => +obj.deptmId === +item.deptmId).deptmNameEn : null,
          spltyName: item.spltyId ? this.specialities.find(obj => +obj.spltyId === +item.spltyId).spltyDescEn : null
        }));
        response.hospSubSpecialityList = response.hospSubSpecialityList.map(item => ({
          ...item,
          ssptyName: item.ssptyId ? this.subSpecialities.find(obj => +obj.ssptyId === +item.ssptyId).ssptyDescEn: null
        }));
        response.hospHyperSpecialityList = response.hospHyperSpecialityList.map(item => ({
          ...item,
          hsptyName: item.hsptyId ? this.hyperSpecialities.find(obj => +obj.hsptyId === +item.hsptyId).hsptyDescEn: null
        }));
        this.newHospital.hospDepartment.departmentList = JSON.parse(JSON.stringify(response.hospDepartmentList));
        this.sharedService.setOrganismDepartment(this.newHospital.hospDepartment.departmentList);
        this.newHospital.hospContact.employeeList = JSON.parse(JSON.stringify(response.hospEmployeeList));
        this.newHospital.hospAddress.addressList = JSON.parse(JSON.stringify(response.hospAddressList));
        this.newHospital.hospSpeciality.specList = JSON.parse(JSON.stringify(response.hospSpecialityList));
        this.newHospital.hospSubSpeciality.subSpecList = JSON.parse(JSON.stringify(response.hospSubSpecialityList));
        this.newHospital.hospHyperSpeciality.hyperSpecList = JSON.parse(JSON.stringify(response.hospHyperSpecialityList));
        this.newHospital.phoneNos.forEach(phone => {
          phone.phone=phone.getInternationPhoneFormat(response[phone.type]);
      })
      }
      this.loaderService.display(false);
    },
    error => {
      this.loaderService.display(false);
    })
  }

  onRowClicked(event: any) {
    this.addHospital = true;
    this.toggleColumn = false;
    this.newHospital.addHospitalTitle = false;
    this.newHospital.editHospitalTitle = true;
    this.loadHospitalById(event);
  }

  hideRightDiv() {
    this.addHospital = false;
    this.toggleColumn = true;
  }

  searchHospitals() {
    this.startIndex = 0;
    this.rowsPerPage = CommonConstants.PAGINATION_SIZE;
    this.paginatedList();
    this.hideRightDiv();
    /* this.hospitalService.searchHospitals(this.hospitalSearch).subscribe(response => {
      console.log(response['result']);
      this.rowData = response['result'];
    }) */
  }

  paginatedList() {
    this.loaderService.display(true);
    this.pSearch.pSearch['partnerType'] = 2;
    this.pSearch.pSearch['active']=this.pSearch.pSearch['active'] ? 'A' :'I';
    this.hospitalService.searchHospitals(this.pSearch.pSearch, this.startIndex).subscribe(response => {
      this.loaderService.display(false);
      let result = response['result'];
      if (result) {
        result = result.map(item => ({
          ...item,
          orgName: item.orgsmId ? this.organisms.find(obj => obj.orgsmId === item.orgsmId).compaVaNameEn : null
        }))
      }
      this.rowData = result;
      this.totalRecords = result.length;
    },
    error => {
      this.loaderService.display(false);
    })
  }

  paginate(event: any) {
    this.startIndex = event.first;
    this.rowsPerPage = event.rows;
    this.paginatedList();
  }

  reset() {
    this.hospitalSearch = new HospitalModel();
    this.hospitalSearch.orgsmId = this.hospitalSearch.cotryId = this.hospitalSearch.townId = null;
    this.rowData =[];
    this.pSearch.pSearch={};
    this.hideRightDiv();
  }

}
